module.exports = __webpack_public_path__ + "static/media/crop-simple-solid.e81c1747.svg";